/**
 * Scoped page translator that never surfaces raw i18n key paths in the UI.
 */
export function makePageT(t, prefix) {
  return (key, opts) => {
    if (!key) return opts?.defaultValue ?? '';
    const fullKey = `${prefix}.${key}`;
    const result = t(fullKey, { ...opts, defaultValue: opts?.defaultValue ?? '' });
    if (result === fullKey || (typeof result === 'string' && result.startsWith('modules.'))) {
      return opts?.defaultValue ?? '';
    }
    return result;
  };
}

/** Keys that usually live under modules.*.pages.common */
const COMMON_KEY_PREFIXES = [
  'req_', 'status_', 'priority_', 'entity_', 'filter_', 'type_', 'svc_',
  'doc_', 'cat_', 'ann_', 'leave_', 'contract_', 'train_', 'perf_',
];

export function isCommonPageKey(key) {
  return COMMON_KEY_PREFIXES.some((prefix) => key.startsWith(prefix));
}

/**
 * Page + common translators for module CRUD shells.
 * `pl` resolves shared keys from common first, then page-specific keys.
 */
export function makeModulePageTranslators(t, moduleName, pageNs) {
  const pagePrefix = `modules.${moduleName}.pages.${pageNs}`;
  const commonPrefix = `modules.${moduleName}.pages.common`;
  const p = makePageT(t, pagePrefix);
  const pc = makePageT(t, commonPrefix);

  const pl = (key, opts) => {
    if (!key) return opts?.defaultValue ?? '';
    if (isCommonPageKey(key)) {
      const common = pc(key, opts);
      if (common) return common;
    }
    const page = p(key, opts);
    if (page) return page;
    return pc(key, opts) || opts?.defaultValue || '';
  };

  return { p, pc, pl, pagePrefix, commonPrefix };
}
